export const DEFAULT_BOOKING_ACCENT = '#5777DA';

export const MIN_TEXT_CONTRAST = 4.5;
export const CARD_BORDER_CONTRAST_THRESHOLD = 1.25;

export const TINT_RATIO = 0.08;
// Capped by `#666666` keeping 4.5:1 on the strong tint of a black control.
export const TINT_STRONG_RATIO = 0.1;

export const CONTROL_HOVER_LIGHTNESS_STEP = 0.03;

export const BOOKING_BRANDING_ERROR_CODES = {
  UNSUPPORTED_FILE_TYPE: 'UNSUPPORTED_FILE_TYPE',
  FILE_TOO_LARGE: 'FILE_TOO_LARGE',
  IMAGE_DIMENSIONS_TOO_LARGE: 'IMAGE_DIMENSIONS_TOO_LARGE',
  LOGO_PROCESSING_TIMEOUT: 'LOGO_PROCESSING_TIMEOUT',
  LOGO_PROCESSING_FAILED: 'LOGO_PROCESSING_FAILED',
  INVALID_BOOKING_PAGE_NAME: 'INVALID_BOOKING_PAGE_NAME',
} as const;

export type BookingBrandingErrorCode =
  (typeof BOOKING_BRANDING_ERROR_CODES)[keyof typeof BOOKING_BRANDING_ERROR_CODES];

export const MAX_LOGO_BYTES = 2_097_152;

export const LOGO_ACTIONS = ['keep', 'replace', 'remove'] as const;

export type LogoAction = (typeof LOGO_ACTIONS)[number];
